import React, { Suspense } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { QueryClientProvider, QueryClient } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import appReducer from './store/reducers/app';
import authReducer from './store/reducers/auth';
import entitiesReducer from './store/reducers/entities'
import campaignsReducer from './store/reducers/campaigns'
import usersReducer from './store/reducers/users'
import { Provider } from 'react-redux';
import { thunk } from 'redux-thunk';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    app: appReducer,
    auth: authReducer,
    users: usersReducer,
    campaigns: campaignsReducer,
    entities: entitiesReducer,
    


})
const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
))
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            cacheTime: Infinity, // Durée de mise en cache infinie
            staleTime: Infinity, // Durée avant de considérer les données comme "stale" (infini pour toujours les garder en cache)
        },
    },
});

const referrer = window.location.origin;
if (referrer.includes('--')) {
    localStorage.setItem("ParenteReferrer", referrer.split("--")[0] + "-" + import.meta.env.VITE_WEB_APP_SUFFIX_URL)
} else {
    localStorage.setItem("ParenteReferrer", referrer.split("-")[0] + "-" + import.meta.env.VITE_WEB_APP_SUFFIX_URL)
}



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <QueryClientProvider client={queryClient}>
    <Provider store={store}>
        <Suspense fallback={(<div>loading ...</div>)}>
            <React.StrictMode>
                <BrowserRouter>
                    <App/>
                </BrowserRouter>
            </React.StrictMode>
        </Suspense>
        </Provider>
    </QueryClientProvider>

);

